export enum AppsModal {
  AddConnection = "addConnection",
}
